<template lang="pug">
#diagnostico-socioambiental
    section.diagnostico-socioambiental__resultado
        .diagnostico-socioambiental__resultado__header
            i.lyra-voltar.mr-2(
                @click='clear',
                v-if='dadosConsultaBuffer || dadosConsulta'
            )
            h1 {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}

        .diagnostico-socionambiental__resultado__protocolo
            section.d-flex.flex-column.mb-3(v-if='!dadosConsulta && protocolos.length > 0')
                div.d-flex.align-items-center
                    h3 {{ $t('mensagens.diagnosticoSocioambiental.selecioneProtocoloParaAnalisar') }}
                        i.el-input__icon.el-icon-info(
                            v-if='protocolos.length <= 1',
                            slot='suffix',
                            :title="$t('mensagens.blocoFiltros.infos.selecionarProtocoloParaDiagnostico')"
                        )
                el-select(
                    :disabled='protocolos.length === 1',
                    v-model='selectedProtocolo'
                )
                    el-option(
                        v-for='protocolo in protocolos',
                        :key='protocolo.codigo',
                        :label='protocolo.descricao',
                        :value='protocolo.codigo'
                    )

        .diagnostico-socioambiental__resultado__body
            section.d-flex.flex-column.mb-3(v-if='!dadosConsulta')
                div(v-if='!permissaoAmbiente(this.ambientes.NORTE_AMERICA)')
                    p {{ $t('mensagens.diagnosticoSocioambiental.utilizeCamposAbaixoParaRealizarDiagnostico') }}
                    .pesquisa
                        label(for='barra-pesquisa') {{ $t('mensagens.diagnosticoSocioambiental.pesquisa') }}
                            i.mdi.mdi-information-outline(
                                slot='suffix',
                                style='margin-left: 3.5px',
                                :title="$t('mensagens.blocoFiltros.infos.pesquisarCarDocumento')"
                            )
                        el-input#barra-pesquisa(
                            type='text',
                            :maxlength='50',
                            :placeholder="$t('mensagens.diagnosticoSocioambiental.pesquisaPlaceholder')",
                            style='width: 100%',
                            :class="{'border-error': pesquisaComErro !== ''}",
                            v-model='pesquisa',
                            @keyup.native.enter="pesquisar"
                        )
                        div.pesquisa-errada(v-if="pesquisaComErro !== '' && foiPesquisado")
                            .conteudo-erro
                                i.el-icon-warning
                                label {{ pesquisaComErro }}
                    div.d-flex.align-items-center.mt-2(v-if="carCheckboxVisible")
                        el-checkbox.ml-0(
                            v-model="buscarCarCpfCnpj"
                        )
                        span.ml-1(style='font-size: 0.9rem', @click='buscarCarCpfCnpj = !buscarCarCpfCnpj') {{ $t('mensagens.diagnosticoSocioambiental.buscarCarsEParcelasVinculadasAoCpfCnpj') }}

                    el-divider(content-position="center") {{ $t('mensagens.diagnosticoSocioambiental.ou') }}

                .upload
                    label {{ $t('mensagens.diagnosticoSocioambiental.pesquisaPorArquivo') }}
                    el-upload.upload-demo(
                        drag,
                        :file-list='fileList',
                        action='alert',
                        :auto-upload='false',
                        :on-change='onLoadFile',
                        :on-remove='onRemoveFile',
                        :on-exceed='onLimitExceed',
                        :limit='1',
                        ref='upload'
                    ).mb-2
                        i.el-icon-upload
                        .el-upload__text {{ $t('mensagens.operacao.textoUpload1') }} <em>{{ $t('mensagens.operacao.textoUpload2') }}</em>
                        .el-upload__text(style='font: 400 12px Roboto, sans-serif !important;') {{ $t('mensagens.diagnosticoSocioambiental.uploadFile.tiposUploadArquivo') }}

                .pesquisa-vazia(v-if="pesquisaInvalida !== '' && foiPesquisado")
                    .conteudo-vazio
                        i.el-icon-error
                        label {{ pesquisaInvalida }}

                BaseButton.primary-button(
                    type='primary',
                    @click='pesquisar'
                )
                    | {{ $t('mensagens.comuns.pesquisar') }}

                div.d-flex.flex-column(v-if="!ambienteAr && !permissaoAmbiente(this.ambientes.NORTE_AMERICA)")
                    p {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoEmLote') }}

                    BaseButton.outline-button(
                        type='outline',
                        @click='abrirModalDiagnosticoSociambientalEmLote'
                    )
                        | {{ $t('mensagens.diagnosticoSocioambiental.realizarDiagnosticoSocioambiental') }}

            section(v-if='dadosConsulta')
                .mb-3
                    h3.font_weight_bold {{ $t('mensagens.diagnosticoSocioambiental.resultadoDiagnostico') }}
                    b(style='font-weight: 400') {{ pesquisado }}

                .mb-3(v-if='informacoes_gerais !== null')
                    card-informacoes-gerais-car(
                        :informacoes_gerais='informacoes_gerais',
                        :refMapa='refMapa',
                        :tipoPesquisa='tipoPesquisa',
                        :pesquisado='pesquisado'
                    )

                div(
                    style='border-bottom: solid 1px var(--default-border-color)',
                    v-if='protocoloUtilizadoFormatado'
                )
                    .d-flex.align-items-center(style='height: 40px')
                        b.font_weight_bold {{ $t('mensagens.diagnosticoSocioambiental.protocoloUtilizado') }}
                        i.mdi.mdi-information-outline(
                            v-if='!permissaoAmbiente(this.ambientes.NORTE_AMERICA)'
                            style='width: 25px; text-align: center;',
                            slot='suffix',
                            :title="$t('mensagens.blocoFiltros.infos.selecionarProtocoloParaDiagnostico')"
                        )
                    p(style='font-weight: 400') {{ protocoloUtilizadoFormatado }}

                h3(style='margin-top: 16px') {{ $t('mensagens.diagnosticoSocioambiental.resultadoDaAnalise') }}

                DiagnosticoSocioambiental.mb-3(
                    v-if='refMapa',
                    style='padding: 0; display: grid',
                    :dadosConsulta='dadosConsulta',
                    :habilitar-opacidade='true',
                    v-bind:cpfCnpj='getCpfCnpj()',
                    v-bind:car='getCar()',
                    @index-aberto='mostrarAreasDiagnosticoNoMapa',
                    :fecharCollapses='true',
                    :mapaLeaflet='refMapa',
                    :habilitar-zoom-restricao='true',
                    :habilitar-sinal-aviso='true',
                    :indexCollapse='0'
                )

            section.mt-3(v-if='dadosConsultaBuffer')
                h3.mb-3
                    i.el-icon-connection
                    b {{ tituloProximidade }}
                DiagnosticoSocioambiental.mb-3(
                    style='padding: 0; display: grid',
                    :dadosConsulta='dadosConsultaBuffer',
                    :habilitar-sinal-aviso='dadosConsultaBuffer.habilitarAlertaProximidade',
                    v-bind:cpfCnpj='getCpfCnpj()',
                    v-bind:car='getCar()',
                    @index-aberto='mostrarAreasDiagnosticoNoMapa',
                    :mapaLeaflet='refMapa',
                    :habilitar-zoom-restricao='true',
                    :indexCollapse='1'
                )

        .diagnostico-socioambiental__resultado__actions
            BaseButton(
                v-if='pesquisaValida && pesquisa !== null && dadosConsulta !== null',
                type='secondary',
                size='small',
                @click='marcarExportacaoDiagnosticPdf',
                style='border-color: var(--primary); color: var(--primary)'
            )
                span {{ $t('mensagens.diagnosticoSocioambiental.marcarExportacao') }}

            el-dropdown(
                v-if='pesquisaValida && pesquisa !== null && dadosConsulta !== null',
                v-bind:disabled='loadingPDF',
                size='small'
            )
                BaseButton.button-exportar(
                    type='primary',
                    @click='!hasDadosConsultaBuffer ? exportarPdfDiagnosticoSocio(false) : undefined'
                )
                    i.lyra-download-socio(v-if='!loadingPDF')
                    i.el-icon-loading(v-if='loadingPDF')
                    span(style='margin-left: 0.5rem') {{ $t('mensagens.diagnosticoSocioambiental.exportarDiagnostico') }}

                el-dropdown-menu.downloadMenu(
                    v-if='hasDadosConsultaBuffer',
                    slot='dropdown'
                )
                    el-dropdown-item
                        BaseButton(
                            type='primary',
                            @click='exportarPdfDiagnosticoSocio(false)',
                            icon='el-icon-download'
                        ) {{ $t('mensagens.diagnosticoSocioambiental.territorio') }}
                    br
                    el-dropdown-item.spaceProximidades
                        BaseButton(
                            type='primary',
                            @click='exportarPdfDiagnosticoSocio(true)',
                            icon='el-icon-download'
                        ) {{ $t('mensagens.diagnosticoSocioambiental.territorioProximidades') }}

    section.diagnostico-socioambiental__mapa.mapa.w-100.h-100
        mapa(
            :showStatesLayers='true',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :height='"100%"',
            :idMapa='"mapaDiagnosticoSocioambiental"',
            @diagnostico='realizarDiagnosticoPeloMapa',
            ref='mapa',
            :atualizarMapa='true',
            :cluster='false',
            :menuMaior='true'
        )

    ModalSelecionarDadosCpfCnpj(
        :show='mostrarModalDadosCpfCnpj',
        :cpfCnpj='pesquisa',
        :dados='dados',
        tipo='DIAGNOSTICO',
        @voltar='mostrarModalDadosCpfCnpj = false',
        @retornarDadosSelecionados='realizarDiagnosticoDadoCpfCnpj'
    )
    ModalDiagnosticoSociambientalEmLote(
        :show='mostrarModalDiagnosticoSociambientalEmLote',
        :dados='dados',
        :protocolo='this.selectedProtocolo ? this.selectedProtocolo : null',
        @voltar='mostrarModalDiagnosticoSociambientalEmLote = false'
    )
</template>

<script>
import L from 'leaflet';
import CardInformacoesGeraisCar from '@/components/diagnosticoSocioambiental/CardInformacoesGeraisCar.vue';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import ModalDiagnosticoSociambientalEmLote from '@/components/diagnosticoSocioambiental/ModalDiagnosticoSociambientalEmLote.vue';
import validators from '@/utils/validators';
import formatters from '@/utils/formatters';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { retryOperation } from '@/utils/retry-operation';

import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';

import { sortBy } from 'lodash';

import geoJsonConverter from '@/utils/conversorGeojson';

import { mapActions, mapGetters, mapState } from 'vuex';
import { TipoAcaoGeometriaDesenhada } from '@/constants/TipoAcaoGeometriaDesenhada';

import CarService from '@/services/car/CarService';
import MunicipioService from '@/services/MunicipioService';
import ModalSelecionarDadosCpfCnpj from '@/components/ModalSelecionarDadosCpfCnpj';
import EventBus from '@/utils/eventBus';
import { connect, disconnect, subscribe } from '@/utils/websocket';
import SigefService from '@/services/SigefService';
import CarUtils from '@/utils/CarUtils';
import { ProtocolosService } from '@/services/ProtocolosService';

import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado';

export default {
    name: 'index',

    components: {
        Mapa,
        DiagnosticoSocioambiental,
        ModalDiagnosticoSociambientalEmLote,
        ModalSelecionarDadosCpfCnpj,
        BaseButton,
        CardInformacoesGeraisCar
    },

    data() {
        return {
            dadosConsulta: null,
            dadosConsultaBuffer: null,
            pesquisa: '',
            pesquisado: '',
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                diagnostico: true
            },
            pesquisaValida: true,
            tipoPesquisa: null,
            foiPesquisado: false,
            pesquisaInvalida: '',
            pesquisaComErro: '',
            loadingPDF: false,
            error: 'error',
            fileList: [],
            uploadFile: null,
            camadasAtivas: [],
            mostrarModalDadosCpfCnpj: false,
            mostrarModalDiagnosticoSociambientalEmLote: false,
            informacoes_gerais: null,
            carsCpfCnpj: [],
            carVinculadoCpfCnpj: null,
            markers: null,
            territorioId: null,
            municipioBuffer: {},
            dados: {
                carEstadoPaginado: [],
                existemDados: false,
                sigef: []
            },
            tituloProximidade: '',
            idDiagnosticoSocioambiental: null,
            geometriaSigef: null,
            refMapa: null,
            voltarHome: false,
            protocolos: [],
            selectedProtocolo: '',
            protocoloUtilizado: '',
            protocoloUtilizadoFormatado: '',
            buscarCarCpfCnpj: false,
            carCheckboxVisible: false,
            collapse: ['informacoes_gerais'],
            ambientes: AmbientesEmpresas
        };
    },

    computed: {
        ...mapGetters([
            'geometriaDesenhadaAcao',
            'acaoEscolhida',
            'usuarioLogado',
            'ambienteAr'
        ]),
        ambienteNorthAmerica() {
            return (
                this.usuarioLogado &&
                this.usuarioLogado.paisGrupo === AmbientesEmpresas.NORTE_AMERICA
            );
        },
        hasDadosConsultaBuffer() {
            return this.dadosConsultaBuffer !== null;
        },
        ...mapState(['usuarioLogado'])
    },

    mounted() {
        this.refMapa = this.$refs.mapa;
    },

    async created() {
        EventBus.$off('mapa:buffer-click');
        this.$nextTick(function () {
            EventBus.$on('mapa:buffer-click', this.bufferCLick);
        });

        await this.buscarProtocolosPorUsuario();
        if (
            this.acaoEscolhida &&
            this.acaoEscolhida.acao ===
                TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
        ) {
            this.tipoPesquisa = 'GEOMETRIA';
            await this.buscarDadosConsulta();
            await this.mostrarTerritorioNoMapa(this.geometriaDesenhadaAcao);
        }

        if (this.$route.params.pesquisa) {
            this.pesquisa = this.$route.params.pesquisa;

            // Detecta CAR estadual MT (formato: MT/NNNN ou MTNNNN, até 13 caracteres)
            const valorSemMascara = this.pesquisa.replace(/[^\w\s]/gi, '').toUpperCase();
            const isCarEstadualMT = valorSemMascara.startsWith('MT') && valorSemMascara.length <= 12;

            const tipoPesquisa = {
                0: this.uploadFile ? 'ARQUIVO' : null,
                13: 'INCRA',
                14: validators.validarDocumento(this.pesquisa) ? 'CPF_CNPJ' : null,
                18: validators.validarDocumento(this.pesquisa) ? 'CPF_CNPJ' : null,
                36: 'SIGEF',
                43: 'CODIGOCAR'
            };

            // CAR estadual MT tem prioridade sobre a detecção por comprimento
            if (isCarEstadualMT) {
                this.tipoPesquisa = 'CAR_ESTADUAL_MT';
            } else {
                this.tipoPesquisa = tipoPesquisa[this.pesquisa.length];
            }
            this.pesquisaValida = this.tipoPesquisa != null;
            this.voltarHome = true;
            await this.pesquisar();
        }

        this.$bus.$on('mapa:camadas-ativas-diagnostico', data => {
            this.camadasAtivas = [];
            data.map(layer => {
                this.camadasAtivas.push(layer.layerName);
            });
        });
    },

    beforeDestroy() {
        this.removerAcaoEscolhida();
        this.removerGeometriaDesenhadaAcao();
    },

    watch: {
        pesquisa: function (value) {
            if (!value) return;

            // Detecta CAR estadual MT (formato: MT/NNNN ou MTNNNN, até 13 caracteres)
            const valorSemMascara = value.replace(/[^\w\s]/gi, '').toUpperCase();
            const isCarEstadualMT = valorSemMascara.startsWith('MT') && valorSemMascara.length <= 12;

            const tipoPesquisa = {
                0: this.uploadFile ? 'ARQUIVO' : null,
                13: 'INCRA',
                14: validators.validarDocumento(value) ? 'CPF_CNPJ' : null,
                18: validators.validarDocumento(value) ? 'CPF_CNPJ' : null,
                36: 'SIGEF',
                43: 'CODIGOCAR'
            };

            // CAR estadual MT tem prioridade sobre a detecção por comprimento
            if (isCarEstadualMT) {
                this.tipoPesquisa = 'CAR_ESTADUAL_MT';
            } else {
                this.tipoPesquisa = tipoPesquisa[value.length];
            }
            this.pesquisaValida = this.tipoPesquisa != null;
            this.pesquisa = this.mascaraPesquisa(value);
            this.habilitaCarCheckbox();
        },

        uploadFile: function () {
            this.pesquisaValida = true;
            this.tipoPesquisa = this.uploadFile ? 'ARQUIVO' : 'null';
        }
    },

    methods: {
        ...mapActions([
            'removerGeometriaDesenhadaAcao',
            'removerAcaoEscolhida',
            'setGeometriaDesenhadaAcao',
            'setAcaoEscolhida',
            'setMarcarExportar_PDF'
        ]),

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.paisGrupo === ambiente;
        },

        abrirModalDiagnosticoSociambientalEmLote() {
            this.mostrarModalDiagnosticoSociambientalEmLote = true;
        },

        validaSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t('mensagens.diagnosticoSocioambiental.situacoes.ativo');
                case 'PE':
                    return this.$t('mensagens.diagnosticoSocioambiental.situacoes.pendente');
                case 'SU':
                    return this.$t('mensagens.diagnosticoSocioambiental.situacoes.suspenso');
                case 'CA':
                    return this.$t('mensagens.diagnosticoSocioambiental.situacoes.cancelado');
                case 'RE':
                    return this.$t('mensagens.diagnosticoSocioambiental.situacoes.retificado');
            }
        },

        getCpfCnpj() {
            if (
                this.tipoPesquisa === 'CPF_CNPJ' ||
                this.tipoPesquisa === 'CPF_CNPJ_NEW'
            ) {
                return this.pesquisa;
            }
            return null;
        },

        getCar() {
            if (this.tipoPesquisa === 'CODIGOCAR' || this.tipoPesquisa === 'CAR_ESTADUAL_MT') {
                const car = this.pesquisa.toUpperCase();
                if (car.startsWith('PA') || car.startsWith('MT')) {
                    return this.pesquisa;
                }
            }
            return null;
        },

        clear() {
            if (this.voltarHome) {
                this.$router.push({
                    name: 'Home'
                });
            } else {
                this.pesquisa = '';
                this.pesquisado = '';
                this.onRemoveFile();
                this.$bus.$emit('mapa:show-buffer', false);
                this.clearMarkes();
                this.carCheckboxVisible = false;
            }
        },

        realizarDiagnosticoPeloMapa() {
            this.setGeometriaDesenhadaAcao(this.geometriaDesenhadaAcao);
            this.setAcaoEscolhida({
                acao: TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            });

            this.mostrarTerritorioNoMapa(this.geometriaDesenhadaAcao);
            this.tipoPesquisa = 'GEOMETRIA';
            this.buscarDadosConsulta();
        },

        async pesquisar() {
            this.foiPesquisado = true;

            if (
                this.acaoEscolhida &&
                this.acaoEscolhida.acao ===
                    TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            ) {
                this.removerAcaoEscolhida();
                this.removerGeometriaDesenhadaAcao();
            }

            await this.buscarDadosConsulta();

            if (this.tipoPesquisa === 'ARQUIVO') {
                this.pesquisa = '';
            } else {
                this.fileList = [];
                this.uploadFile = null;
            }
            this.dadosConsultaBuffer = null;
            this.mostrarTerritorioNoMapa();
            this.habilitaCarCheckbox();
        },

        processarDiagnosticoSocioambientalGoogleAnalytics() {
            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'REALIZAR_DIAGNOSTICO_SOCIOAMBIENTAL', pageTitle: 'REALIZAR_DIAGNOSTICO_SOCIOAMBIENTAL', routeName: this.$route?.name, routePath: this.$route?.path });
        },

        async bufferCLick() {
            let response = null;
            try {
                const geometria = Array.isArray(
                    this.dadosConsulta.imovel.geometria
                )
                    ? this.dadosConsulta.imovel.geometria.map(g =>
                          JSON.stringify(g)
                      )
                    : [JSON.stringify(this.dadosConsulta.imovel.geometria)];

                response =
                    await DiagnosticoSocioambientalService.analisarBuffer(
                        geometria,
                        this.idDiagnosticoSocioambiental,
                        this.selectedProtocolo ? this.selectedProtocolo : null
                    );

                const diagnosticos = [];
                response.data.dados.forEach(d =>
                    d.forEach(t => {
                        diagnosticos.push(t);
                    })
                );

                const geometrias = [];
                response.data.geometrias.forEach(g => {
                    geometrias.push(JSON.parse(g));
                });

                this.dadosConsultaBuffer = {
                    diagnosticos:
                        this.ordenarDiagnosticoPorCamada(diagnosticos),
                    geometria: geometrias,
                    habilitarAlertaProximidade:
                        response.data.habilitarAlertaProximidade
                };

                this.tituloProximidade = response.data.tituloProximidade;

                this.mostrarTerritorioNoMapa();
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.buscarDadosBuffer')
                });
            }
        },

        ordenarDiagnosticoPorCamada(diagnosticos) {
            diagnosticos = diagnosticos.map(d => ({
                ...d,
                camada: { ...d.camada, opacidade: 100 },
                nivelAlerta: d.nivelAlerta,
                status: d.status
            }));

            diagnosticos.forEach(diagnostico => {
                if (diagnostico.camada.nome === 'Áreas embargadas') {
                    diagnostico.camada.nome = 'Áreas embargadas (IBAMA)';
                } else if (
                    diagnostico.camada.nome === 'Monitoramento Desmatamento'
                ) {
                    diagnostico.camada.nome = 'Desmatamento Lyra';
                }

                if (this.ambienteNorthAmerica) {
                    diagnostico.resultados = diagnostico.resultados.filter(
                        resultado => Number(resultado?.properties?.areaHa) > 1
                    );
                }
            });

            return sortBy(diagnosticos, [
                diagnostico => diagnostico.camada.codigo
            ]);
        },

        async getDadosMunicipio(item) {
            const idMunicipio = item.properties.id_municipio;

            if (this.municipioBuffer[idMunicipio]) {
                return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
            } else {
                try {
                    const { data } = await MunicipioService.getMunicipioById(
                        idMunicipio
                    );
                    this.municipioBuffer[idMunicipio] = data;
                    return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
                } catch (e) {
                    this.$notify.error({
                        message: this.$t('mensagens.diagnosticoSocioambiental.erro.buscarDadosMunicipios')
                    });
                    return '-';
                }
            }
        },

        async buscarDadosConsulta() {
            this.territorioId = null;
            let tipoConsulta = null;
            this.geometriaSigef = null;

            if (this.tipoPesquisa === 'SIGEF') {
                const { data } = await SigefService.buscarGeometriaParcela(
                    this.pesquisa
                );

                if (data !== '') {
                    this.geometriaSigef = JSON.parse(data);
                    this.pesquisaValida = true;
                } else if (this.pesquisa === '') {
                    this.pesquisaComErro = '';
                    this.pesquisaInvalida = this.$t('mensagens.diagnosticoSocioambiental.erro.pesquisaInvalidaVazia');
                    return;
                } else {
                    this.pesquisaInvalida = '';
                    this.pesquisaComErro = this.$t('mensagens.diagnosticoSocioambiental.erro.parcelaNaoEncontrada');
                    return;
                }
            }

            try {
                let consultaResponse = null;
                switch (this.tipoPesquisa) {
                    case 'CODIGOCAR':
                        tipoConsulta = 'CAR';
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'CODIGOCAR',
                                this.pesquisa.toUpperCase(),
                                true,
                                true,
                                null,
                                this.selectedProtocolo ? this.selectedProtocolo : null
                            );
                        break;
                    case 'CAR_ESTADUAL_MT':
                        tipoConsulta = 'CAR';
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'CAR_ESTADUAL_MT',
                                this.pesquisa.toUpperCase(),
                                true,
                                true,
                                null,
                                this.selectedProtocolo ? this.selectedProtocolo : null
                            );
                        break;
                    case 'ARQUIVO':
                        tipoConsulta = 'ARQUIVO';
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'GEOMETRIA',
                                'geometria',
                                true,
                                true,
                                this.prepararArquivoParaConsulta(this.uploadFile.file),
                                this.selectedProtocolo ? this.selectedProtocolo : null
                            );
                        break;
                    case 'CPF_CNPJ':
                        tipoConsulta = 'CPF/CNPJ';
                        const cpfCnpj = this.pesquisa.replace(/\D/g, '');
                        let listaSigef = [];
                        if (this.buscarCarCpfCnpj) {
                            const cars = await this.buscarCarPorCpfCnpjVinculado(
                                    cpfCnpj
                                );
                            listaSigef = await this.buscarDadosSigefCpfCnpj(
                                cpfCnpj
                            );
                            this.dados = {
                                listaSigef,
                                ...cars
                            };
                            this.mostrarModalDadosCpfCnpj = true;
                            return;
                        } else {
                            consultaResponse =
                                await DiagnosticoSocioambientalService.consultar(
                                    'CPF_CNPJ',
                                    formatters.documentoFormatToNumeral(cpfCnpj),
                                    true,
                                    true,
                                    null,
                                    this.selectedProtocolo ? this.selectedProtocolo : null
                                );
                        }
                        break;
                    case 'CPF_CNPJ_NEW':
                        tipoConsulta = 'CPF/CNPJ';
                        this.carCheckboxVisible = false;
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'CPF_CNPJ',
                                formatters.documentoFormatToNumeral(
                                    this.pesquisa.replace(/\D/g, '')
                                ),
                                true,
                                true,
                                null,
                                this.selectedProtocolo ? this.selectedProtocolo : null
                            );
                        break;
                    case 'GEOMETRIA':
                    case 'SIGEF':
                        this.tipoConsulta = 'GEOMETRIA';
                        let geometriaConsulta = [this.geometriaDesenhadaAcao];

                        if (this.geometriaSigef) {
                            geometriaConsulta = [this.geometriaSigef];
                        }

                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'GEOMETRIA',
                                'geometria',
                                true,
                                true,
                                JSON.stringify(geometriaConsulta),
                                this.selectedProtocolo ? this.selectedProtocolo : null
                            );
                        this.mostrarTerritorioNoMapa(geometriaConsulta);
                        this.tipoPesquisa = 'GEOMETRIA';
                        break;
                    case 'INCRA':
                        tipoConsulta = 'INCRA';
                        const listaSigefINCRA =
                            await this.buscarDadosSigefINCRA(this.pesquisa);

                        this.dados = {
                            listaSigef: listaSigefINCRA
                        };

                        if (listaSigefINCRA.length) {
                            this.pesquisa = 'INCRA';
                            this.mostrarModalDadosCpfCnpj = true;
                            return;
                        } else if (this.pesquisa === '') {
                            this.pesquisaComErro = '';
                            this.pesquisaInvalida = this.$t('mensagens.diagnosticoSocioambiental.erro.pesquisaInvalidaVazia');
                        } else {
                            this.pesquisaInvalida = '';
                            this.pesquisaComErro = this.$t('mensagens.diagnosticoSocioambiental.erro.parcelaNaoEncontradaParcelaRelacionada');
                        }
                        break;
                    default:
                        this.$notify.warning(
                            this.$t('mensagens.diagnosticoSocioambiental.erro.tipoConsultaNaoConhecido') + this.tipoPesquisa
                        );
                        return;
                }

                if (consultaResponse) {
                    this.informacoes_gerais =
                        consultaResponse.data.informacoes_gerais;
                }
                this.protocoloUtilizado = consultaResponse.data.protocolo;
                this.protocoloUtilizadoFormatado = consultaResponse.data.protocoloDescricao;

                this.idDiagnosticoSocioambiental =
                    consultaResponse.data.idDiagnosticoSocioambiental;

                let dados = consultaResponse.data.dataCAR;
                if (dados.length === 0) {
                    this.pesquisaComErro = this.$t('mensagens.diagnosticoSocioambiental.erro.carNaoEncontrado');
                } else {
                    this.territorioId = consultaResponse.data.territorioId;

                    this.dadosConsulta = dados[0].diagnosticos
                        ? {
                              ...dados[0],
                              diagnosticos: this.ordenarDiagnosticoPorCamada(
                                  dados[0].diagnosticos
                              )
                          }
                        : {
                              diagnosticos:
                                  this.ordenarDiagnosticoPorCamada(dados)
                          };

                    if (this.tipoPesquisa === 'ARQUIVO') {
                        this.dadosConsulta.imovel = {
                            geometria: this.uploadFile.file
                        };
                    }

                    if (this.tipoPesquisa === 'GEOMETRIA') {
                        this.dadosConsulta.imovel = {
                            geometria: this.geometriaSigef
                                ? this.geometriaSigef
                                : this.geometriaDesenhadaAcao
                        };
                    }

                    this.pesquisado =
                        this.tipoPesquisa === 'ARQUIVO'
                            ? this.$t('mensagens.diagnosticoSocioambiental.pesquisaPorArquivo')
                            : this.pesquisa;
                }
                this.pesquisaComErro = '';
                this.pesquisaInvalida = '';
            } catch (error) {
                if (tipoConsulta === 'CAR' && this.pesquisa !== '') {
                    this.pesquisaComErro = this.$t('mensagens.diagnosticoSocioambiental.erro.carInseridoNaoEncontrado');
                    this.pesquisaInvalida = '';
                } else if (tipoConsulta === null &&
                    (this.pesquisa.length === 9 || this.pesquisa.length === 10 ||
                        this.pesquisa.length === 14 || this.pesquisa.length === 18)) {
                    this.pesquisaComErro =
                        this.$t('mensagens.diagnosticoSocioambiental.erro.consulta.1') + this.$t('mensagens.diagnosticoSocioambiental.erro.consulta.documento') +
                        this.$t('mensagens.diagnosticoSocioambiental.erro.consulta.2');
                    this.pesquisaInvalida = '';
                } else if (tipoConsulta !== null && tipoConsulta !== 'ARQUIVO' && this.pesquisa === '') {
                    this.pesquisaComErro = '';
                    this.pesquisaInvalida = this.$t('mensagens.diagnosticoSocioambiental.erro.pesquisaInvalidaVazia');
                } else if (tipoConsulta !== null && tipoConsulta === 'ARQUIVO' && this.pesquisa === '') {
                    this.pesquisaComErro = '';
                    this.pesquisaInvalida = this.$t('mensagens.diagnosticoSocioambiental.erro.erroDiagnosticoGeometriaFornecida');
                } else if (tipoConsulta === null || this.pesquisa === '') {
                    this.pesquisaComErro = '';
                    this.pesquisaInvalida = this.$t('mensagens.diagnosticoSocioambiental.erro.pesquisaInvalidaVazia');
                } else {
                    this.pesquisaComErro =
                        this.$t('mensagens.diagnosticoSocioambiental.erro.consulta.1') +
                        tipoConsulta +
                        this.$t('mensagens.diagnosticoSocioambiental.erro.consulta.2');

                    this.pesquisaInvalida = '';
                }
            }
        },

        realizarDiagnosticoDadoCpfCnpj(dado) {
            this.mostrarModalDadosCpfCnpj = false;
            if (dado.codigo) {
                this.pesquisa = dado.codigo;
                this.tipoPesquisa = 'CODIGOCAR';
            } else if (dado.codigoParcela) {
                this.pesquisa = dado.codigoParcela;
                this.tipoPesquisa = 'SIGEF';
            } else {
                this.pesquisa = dado;
                this.tipoPesquisa = 'CPF_CNPJ_NEW';
                this.buscarDadosConsulta();
            }
        },
        addMarker(geometria) {
            this.clearMarkes();

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            let marker = L.marker(
                [geometria.coordinates[1], geometria.coordinates[0]],
                {
                    icon: pinIcon,
                    draggable: true
                }
            );

            marker.addTo(this.markers);
            this.markers.addTo(this.$refs.mapa.mapa);
        },

        clearMarkes() {
            if (this.markers) {
                this.$refs.mapa.mapa.removeLayer(this.markers);
            }
            this.markers = L.markerClusterGroup();
        },

        mostrarTerritorioNoMapa(geometria, clearLayers) {
            this.processarDiagnosticoSocioambientalGoogleAnalytics();
            if (clearLayers == null || clearLayers) {
                this.layersMaps = [];
            }

            const layersToAdd = [];

            if (
                this.acaoEscolhida &&
                this.acaoEscolhida.acao ===
                    TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            ) {
                geometria = this.geometriaDesenhadaAcao;
                this.dadosConsulta = {
                    imovel: { geometria: this.geometriaDesenhadaAcao },
                    ...this.dadosConsulta
                };
            }

            if (geometria) {
                if (geometria.type === 'Point') {
                    this.addMarker(geometria);
                } else if (geometria[0] && geometria[0].type === 'GeometryCollection') {
                    geometria[0].geometries.forEach(geom => {
                        layersToAdd.push({
                            style: getEstiloGeometria('area'),
                            name: 'Território',
                            geoJson: geom
                        });
                    });
                } else {
                    layersToAdd.push({
                        style: getEstiloGeometria('area'),
                        name: 'Território',
                        geoJson: geometria
                    });
                }
            }
            if (this.dadosConsulta && this.dadosConsulta.imovel) {
                if (this.dadosConsulta.imovel.geometria[0] && this.dadosConsulta.imovel.geometria[0].type === 'GeometryCollection') {
                    this.dadosConsulta.imovel.geometria[0].geometries.forEach(geom => {
                        layersToAdd.push({
                            style: getEstiloGeometria('car'),
                            name: 'Car',
                            geoJson: geom
                        });
                    });
                } else {
                    layersToAdd.push({
                        style: getEstiloGeometria('car'),
                        name: 'Car',
                        geoJson: this.dadosConsulta.imovel.geometria
                    });
                }
                this.$bus.$emit('mapa:show-buffer', true);
            }
            if (
                this.dadosConsultaBuffer &&
                this.dadosConsultaBuffer.geometria
            ) {
                layersToAdd.push({
                    style: getEstiloGeometria('area'),
                    name: 'Território',
                    geoJson: this.dadosConsultaBuffer.geometria
                });

                this.$bus.$emit('mapa:show-buffer', false);
            }
            if (this.geometriaSigef) {
                layersToAdd.push({
                    style: getEstiloGeometria('area'),
                    name: 'Território_Sigef',
                    geoJson: this.geometriaSigef
                });
            }

            layersToAdd.forEach(l => {
                this.layersMaps.push(l);
            });
        },

        mostrarAreasDiagnosticoNoMapa(
            restricao,
            indexCollapse,
            indexRestricao
        ) {
            this.mostrarTerritorioNoMapa();
            if (indexRestricao === '' || indexRestricao === null) return;

            const diagnostico =
                indexCollapse === 0
                    ? this.dadosConsulta.diagnosticos[indexRestricao]
                    : this.dadosConsultaBuffer.diagnosticos[indexRestricao];

            const opacidade =
                diagnostico.camada.opacidade >= 0.0
                    ? diagnostico.camada.opacidade / 200
                    : 0.5;

            const areas = diagnostico.resultados.filter(
                resultado => resultado.geometria || resultado.geometry
            );

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;
                this.layersMaps.push({
                    name: `AreaDiagnostico_red_${indexCollapse}_${indexRestricao}_${index}`,
                    group: `grupo-restricoes-${indexCollapse}-${indexRestricao}`,
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    geoJson: geometria
                });

                const pin = L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico_${index}_${indexCollapse}`,
                    icon: pin,
                    geoJson: centroidFromGeoJSON.get(geometria)
                });
            });
        },

        mostrarAreasDiagnosticoBufferNoMapa(restricao, _, indexCollapseRow) {
            this.mostrarTerritorioNoMapa();
            if (indexCollapseRow === '') return;

            const areas = this.dadosConsultaBuffer.diagnosticos[
                indexCollapseRow
            ].resultados.filter(
                resultado => resultado.geometria || resultado.geometry
            );

            areas.forEach((area, index) => {
                let layerAreaDiagnostico;
                if (
                    restricao &&
                    restricao.index === index &&
                    restricao.overOrLeave === 'over'
                ) {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'orange',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        geoJson: area.geometria || area.geometry
                    };
                } else {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        geoJson: area.geometria || area.geometry
                    };
                }

                this.layersMaps.push(layerAreaDiagnostico);
            });
        },

        async exportarPdfDiagnosticoSocio(buffer) {
            if (!this.usuarioLogado) {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado')
                });
                return;
            }

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelConectarApi')
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = this.$t('mensagens.diagnosticoSocioambiental.pdfTitulo');
                            link.href = linkSource;
                            link.download = fileName;
                            link.click();
                            link.remove();
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf')
                            });
                        }
                        this.loadingPDF = false;
                        disconnect();
                    }
                );

                this.loadingPDF = true;
                let documento = {};

                if (this.tipoPesquisa === 'CODIGOCAR' || this.tipoPesquisa === 'CAR_ESTADUAL_MT') {
                    documento.value = this.pesquisa.toUpperCase();
                } else if (this.tipoPesquisa === 'ARQUIVO') {
                    documento.value = JSON.stringify(this.uploadFile.file);
                    documento.nomeArquivo = this.uploadFile.name;
                } else if (this.tipoPesquisa === 'GEOMETRIA') {
                    documento.value = JSON.stringify([
                        this.geometriaSigef
                            ? this.geometriaSigef
                            : this.geometriaDesenhadaAcao
                    ]);
                } else {
                    documento.value = formatters.documentoFormatToNumeral(
                        this.pesquisa
                    );
                }

                documento.type = this.tipoPesquisa;

                let camadasPdf = this.camadasAtivas;

                documento.type = this.tipoPesquisa;
                if (documento.type === 'CPF_CNPJ_NEW') {
                    documento.type = 'CPF_CNPJ';
                }

                if (
                    this.tipoPesquisa === 'GEOMETRIA' &&
                    !this.geometriaSigef &&
                    this.geometriaDesenhadaAcao.type === 'Point'
                ) {
                    camadasPdf = null;
                }

                const params = {
                    idTerritorio: this.territorioId,
                    tipoDocumento:
                        documento.type === 'ARQUIVO'
                            ? 'GEOMETRIA'
                            : documento.type,
                    documento: documento.value,
                    camadas: camadasPdf,
                    buffer: buffer
                        ? JSON.stringify(this.dadosConsultaBuffer.geometria)
                        : null,
                    nomeArquivo: documento.nomeArquivo || null,
                    protocolo: this.protocoloUtilizado
                };

                const dados = [];
                dados.push(params);

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    dados,
                    5000,
                    10
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf')
                });
                disconnect();
            }
        },

        marcarExportacaoDiagnosticPdf() {
            let documento = {};

            if (this.tipoPesquisa === 'CODIGOCAR' || this.tipoPesquisa === 'CAR_ESTADUAL_MT') {
                documento.value = this.pesquisa.toUpperCase();
                documento.nome = 'CAR ' + this.pesquisa;
            } else if (this.tipoPesquisa === 'ARQUIVO') {
                documento.value = JSON.stringify(this.uploadFile.file);
                documento.nome = this.uploadFile.name;
            } else if (this.tipoPesquisa === 'GEOMETRIA') {
                documento.value = JSON.stringify([
                    this.geometriaSigef
                        ? this.geometriaSigef
                        : this.geometriaDesenhadaAcao
                ]);
                documento.nome = 'Geometria';
            } else {
                documento.value = formatters.documentoFormatToNumeral(
                    this.pesquisa
                );
                documento.nome =
                    'CPF/CNPJ ' +
                    formatters.documentoFormatToNumeral(this.pesquisa);
            }

            documento.type = this.tipoPesquisa;

            let camadasPdf = this.camadasAtivas;

            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: this.territorioId,
                tipoDocumento:
                    this.tipoPesquisa === 'ARQUIVO'
                        ? 'GEOMETRIA'
                        : this.tipoPesquisa,
                documento: documento.value,
                camadas: camadasPdf,
                nome: documento.nome,
                buffer: this.dadosConsultaBuffer
                    ? JSON.stringify(this.dadosConsultaBuffer.geometria)
                    : null,
                nomeArquivo:
                    this.tipoPesquisa === 'ARQUIVO' ? documento.nome : null,
                protocolo: this.protocoloUtilizado,
                protocoloFormatado: this.protocoloUtilizadoFormatado
            };

            this.setMarcarExportar_PDF(params);
        },

        onLimitExceed() {
            this.$notify.warning({
                message: this.$t('mensagens.diagnosticoSocioambiental.erro.umTerritorioPorVez')
            });
        },

        onRemoveFile() {
            this.layersMaps = [];
            this.dadosConsultaBuffer = null;
            this.dadosConsulta = null;
            this.uploadFile = null;
        },

        onLoadFile(file) {
            this.layersMaps = [];

            if (
                this.acaoEscolhida &&
                this.acaoEscolhida.acao ===
                    TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            ) {
                this.removerAcaoEscolhida();
                this.removerGeometriaDesenhadaAcao();
            }

            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geoJsonConverter
                    .parse(extension, e.target.result, file.raw)
                    .then(geoJson => {
                        let dadosArquivo = {
                            id: file.uid,
                            file: geoJson.features.map(f => f.geometry),
                            name: file.name
                        };

                        this.uploadFile = dadosArquivo;

                        this.mostrarTerritorioNoMapa(dadosArquivo.file);
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        formatNumber(input, decimalPlaces) {
            return formatters.formatNumber(input, decimalPlaces);
        },

        async buscarCarPorCpfCnpjVinculado(cpfCnpj) {
            try {
                const { data } = await CarService.buscarCarPorCpfCnpjVinculado(
                    cpfCnpj
                );
                return data;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.erroNaRequisicao')
                });
            }
        },

        async buscarDadosSigefCpfCnpj(cpfCnpj) {
            const { data } = await SigefService.consultarCpfCnpj(cpfCnpj);
            return data;
        },

        async buscarDadosSigefINCRA(incra) {
            const { data } = await SigefService.consultarINCRA(incra);
            return data;
        },

        mascaraPesquisa(value) {
            value = value.replace(/[^\w\s]/gi, '');

            // Detecta CAR estadual MT (formato: MT/NNNN ou MTNNNN, até 12 caracteres sem formatação)
            const isCarEstadualMT = value.toUpperCase().startsWith('MT') && value.length <= 12;

            if (isCarEstadualMT) {
                return formatters.formatCarEstadualMT(value);
            } else if (value.length === 13) {
                return value;
            } else if (value.length === 8 || value.length === 9 || value.length === 11 || value.length === 14) {
                return formatters.numeralStringFormatToDocumento(value);
            } else if (value.length === 32) {
                return formatters.formatCodigoParcela(value);
            } else if (value.length === 41) {
                return CarUtils.addMascaraCar(value).toUpperCase();
            } else {
                return value;
            }
        },

        async buscarProtocolosPorUsuario() {
            this.protocolos = await ProtocolosService.buscarProtocolosPorUsuario();
            this.selectedProtocolo = this.protocolos.find(p => p.protocoloPadrao === true).codigo;
        },
        habilitaCarCheckbox() {
            if (this.tipoPesquisa === 'CPF_CNPJ') {
                this.carCheckboxVisible = true;
            } else {
                this.carCheckboxVisible = false;
            }
            this.buscarCarCpfCnpj = false;
        },
        prepararArquivoParaConsulta(geometries) {
            return JSON.stringify(
                (geometries?.length > 1 && geometries.every(g => g?.type === 'Polygon'))
                ? [{
                    type: 'MultiPolygon',
                    coordinates: geometries.map(g => g.coordinates)
                }]
                : geometries
            );
        }
    }
};
</script>

<style lang="scss">
#diagnostico-socioambiental {
    padding: 20px;
    width: 100%;
    height: 100%;
    display: flex;

    .diagnostico-socioambiental__resultado {
        @include scroll-bar();
        background-color: var(--white);
        border-radius: 5px 0 0 5px;
        padding: 20px;
        overflow-y: auto;
        width: 65%;

        .diagnostico-socioambiental__resultado__header {
            height: auto;
            margin-bottom: 32px;
            display: flex;
            align-items: center;

            h1 {
                font: 500 18px Roboto, sans-serif;
            }
        }

        .diagnostico-socioambiental__resultado__body {
            height: calc(100% - 79px);
            overflow-y: auto;

            p {
                font: 500 14px Roboto, sans-serif;
            }
            .container-restricao p {
                font: 400 13px Roboto, sans-serif;
                color: var(--primary-font-color) !important;
                line-height: 1.77;
            }
        }

        .diagnostico-socioambiental__resultado__actions {
            display: flex;
            justify-content: space-between;
            margin-top: 1.2rem;
        }
    }

    .diagnostico-socioambiental__mapa {
        width: 55%;
    }
}

label {
    font: 14px/150% Roboto, sans-serif;
    margin-bottom: 0.5rem !important;
}

.spaceProximidades {
    margin-top: 5px;
}

.outline-button {
    color: #00413c !important;
    font: 500 14px/143% Roboto, sans-serif !important;
    border: 1px solid #00413c !important;
    margin-bottom: 10px !important;
}

.primary-button {
    margin-top: 16px;
    margin-bottom: 32px !important;
    font: 500 14px/143% Roboto, sans-serif !important;
}

.pesquisa-vazia {
    border-radius: 4px;
    border-color: #f4c1be;
    border-style: solid;
    border-width: 1px;
    background-color: #fcebea;
    display: flex;
    margin: 16px 0 16px 0;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
    .conteudo-vazio {
        display: flex;
        align-items: center;
        gap: 8px;
        label {
            margin-left: 10px !important;
            margin-bottom: 0px !important;
        }
        i {
            font-size: 18px;
            color: var(--danger);
        }
    }
}

.pesquisa-errada {
    display: flex;
    margin-top: 10px !important;
    color: var(--danger);
    .conteudo-erro {
        display: flex;
        label {
            margin: 0 0 0 10px !important;
        }
        i {
            font-size: 18px;
        }
    }
}

.border-error input {
    border-color: var(--danger) !important;
}

.el-upload,
.el-upload-dragger {
    width: 100% !important;
    max-width: 100% !important;
}
.el-upload__text {
    margin-bottom: 11px;
    font: 14px/150% Roboto, sans-serif;
}

.downloadMenu {
    min-width: 180px;
}

.el-dropdown-link-exportar {
    border: 1px solid #babac9;
    padding: 10px 20px;
    color: #19194b;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 400;
    font-size: 13px !important;

    i {
        margin-right: 5px;
    }
}

.el-dropdown-link-exportar:hover {
    background-color: #e8e8ed;
}

.downloadButton {
    background: transparent !important;
    border: none !important;
    text-align: left !important;
    padding: 0 !important;
}

#mapaDiagnosticoSocioambiental {
    border-radius: 0 5px 5px 0;
}

.el-collapse-item__content {
    color: var(--primary-font-color) !important;
}

.el-collapse-item__wrap {
    border-bottom: solid 1px var(--default-border-color) !important;
}

.font_weight_bold {
    font-weight: 500 !important;
}

.button-exportar {
    font-weight: 400 !important;
    font-family: 'Roboto', sans-serif;
}

.lyra-download-socio {
    cursor: pointer;
    content: '';
    width: 11px;
    height: 11px;
    display: inline-block;
    -webkit-mask: url(../../assets/lyra-icons/svg/download.svg) no-repeat 50%
        50%;
    mask: url(../../assets/lyra-icons/svg/download.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
    background-color: var(--white);
    color: var(--white);
}

.lyra-voltar {
    cursor: pointer;
    content: '';
    width: 17px;
    height: 17px;
    display: inline-block;
    -webkit-mask: url(../../assets/lyra-icons/svg/flecha-voltar.svg) no-repeat
        50% 50%;
    mask: url(../../assets/lyra-icons/svg/flecha-voltar.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
    background-color: var(--primary-font-color);
    color: var(--primary-font-color);
}
</style>
